<template>
  <a class="btn btn-themed gray d-md-inline-flex d-block align-items-center excel-btn"
     @click="excel"
     v-if="options && options.actions && options.actions.includes('excel')">
    <ExcelSvg class="svg-gray mr-md-2"/>
    <span>{{ $t('excel') }}</span>
  </a>
</template>

<script setup>
import ExcelSvg from '@/assets/svg-vue/general/excel.svg'
import JwtService from "@/services/jwt.service"
import { EloquentService } from "@/services/api/eloquent.api.service"
import { useStore } from "vuex"
import {computed, inject, getCurrentInstance, onBeforeMount} from "vue"
import {LogService} from "@/services/api/log.api.service"
import {copyObject} from "@/extensions/prototypes/prototypes"

const props = defineProps({
  superadmin: {
    type: Boolean,
    default: false
  },
  sendLogs: {
    type: Boolean,
    default: false
  }
})

const store = useStore()

let i18n = null
let noty = null

const viewModel = computed(() => store.state.datatable.viewModel)
const options = computed(() => store.state.datatable.eloquentOptions)
const additionalParams = computed(() => store.state.datatable.additionalParams)
const clinic = computed(() => store.state.auth.clinic)
const filters = computed(() => store.state.datatable.filters)
const reloadExcelReports = inject('reloadExcelReports')

onBeforeMount(() => {
  const instance = getCurrentInstance()
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

const excel = async () => {
  if(props.sendLogs) {
    LogService.sendActivityLog({
      event: 'exported_patients_to_excel',
      properties: {
        filters: copyObject(filters.value),
        additionalParams: copyObject(additionalParams.value),
      }
    }).then().catch(e => {
      console.log(e)
    })
  }
  const res = await EloquentService.excel(viewModel.value, additionalParams.value, filters.value, props.superadmin)
  if(res.data?.queued) {
    noty.info(i18n.t('your_report_is_processing'))
    reloadExcelReports?.()
    store.commit('setHeaderCounter', { counter: 'excels', value: 1 } )
    return
  }
  const link = JwtService.getPrintPrelink(clinic.value, props.superadmin)
  location.href = link+'/excel/'+res.data.result
}
</script>
